/**
 * Frankfurt Reinigung 24 – zentrale Preiskonfiguration
 * Alle Beträge sind Richtpreise in Euro. Im Rechner werden bewusst keine Netto-/Brutto-Hinweise angezeigt.
 */

export const VAT_RATE = 0.19;

export const SERVICE_TYPES = {
  cleaning: "Reinigung",
  painting: "Malerarbeiten",
  combined: "Reinigung und Malerarbeiten",
  individual: "Individuelle Anfrage",
};

export const FREQUENCY_VISITS = {
  einmalig: 0,
  "1xmonatlich": 1,
  "2xmonatlich": 2,
  "4xmonatlich": 4,
  "8xmonatlich": 8,
  "12xmonatlich": 12,
  "20xmonatlich": 20,
};

export const HOUSING_OCCUPIED = {
  // Bewohnte Wohnung / bewohntes Haus – schlanke Standardreinigung.
  // Enthalten: frei zugängliche Oberflächen, Saugen, Wischen, Küche außen,
  // 1 Bad/WC sowie bis zu 3 leicht verschmutzte Standardfenster inkl. Rahmen.
  tiers: [
    { maxSqm: 55, price: 91.99 },
    { maxSqm: 70, price: 99.99 },
    { maxSqm: 90, price: 109.99 },
    { maxSqm: 110, price: 119.99 },
    { maxSqm: 130, price: 129.99 },
  ],
  maxAutomaticSqm: 130,
  includedStandardWindows: 3,
  extraStandardWindow: 9.00,
  nominalIncludedWindowValue: 9.00,
  extraBathroom: 15.00,
  guestWC: 10.00,
  frequencyFactors: {
    einmalig: 1.00,
    "1xmonatlich": 1.00,
    "2xmonatlich": 1.00,
    "4xmonatlich": 1.00,
    "8xmonatlich": 1.00,
    "12xmonatlich": 1.00,
    "20xmonatlich": 1.00,
  },
};

export const HOUSING = {
  // Endreinigung nach Auszug / intensive Wohnungsreinigung.
  pricePerSqm: 4.25,
  minPrice: 150.42,
  setupOneTime: 29.00,
  setupRegular: 15.00,
  extras: {
    weiteresBadezimmer: 21.01,
    gaesteWC: 12.61,
    backofenInnen: 25.21,
    kuehlschrankInnen: 21.01,
    kuechenschraenkeInnen: 42.02,
    tierhaareAufschlagPct: 0.10,
    raucherobjektAufschlagPct: 0.10,
    hausMehretagenAufschlagPct: 0.10,
  },
  frequencyFactors: {
    einmalig: 1.00,
    "1xmonatlich": 0.80,
    "2xmonatlich": 0.65,
    "4xmonatlich": 0.50,
    "8xmonatlich": 0.47,
    "12xmonatlich": 0.47,
    "20xmonatlich": 0.47,
  },
};

export const BALCONIES = {
  baseBySize: {
    klein: 29.00,
    mittel: 49.00,
    gross: 79.00,
    sehrGross: null,
  },
  soilFactors: {
    leicht: 1.00,
    mittel: 1.30,
    stark: 1.65,
  },
  weedSurcharges: {
    kein: 0.00,
    wenig: 15.00,
    viel: 35.00,
  },
};

export const OFFICE_MAINTENANCE = {
  pricePerSqm: 0.35,
  pricePerToilet: 10.00,
  pricePerKitchen: 10.00,
  minPricePerVisit: 89.00,
  frequencyFactors: {
    "1xmonatlich": 1.30,
    "2xmonatlich": 1.15,
    "4xmonatlich": 1.00,
    "8xmonatlich": 0.95,
    "12xmonatlich": 0.95,
    "20xmonatlich": 0.95,
  },
};

export const OFFICE_STANDARD_ONETIME = {
  pricePerSqm: 1.75,
  minPrice: 199.00,
  setup: 29.00,
  pricePerToilet: 15.00,
  pricePerKitchen: 15.00,
};

export const OFFICE_DEEPCLEAN = {
  pricePerSqm: 3.25,
  minPrice: 299.00,
  setup: 29.00,
  pricePerToilet: 15.00,
  pricePerKitchen: 15.00,
};

export const STUDIOS = {
  fitness: {
    regularPricePerSqm: 0.55,
    minRegular: 119.00,
    pricePerToilet: 10.00,
    pricePerShower: 15.00,
    pricePerChangingRoom: 15.00,
    pricePerKitchen: 10.00,
    largeMirrors: 25.00,
  },
  standard: {
    regularPricePerSqm: 0.45,
    minRegular: 99.00,
    pricePerToilet: 10.00,
    pricePerShower: 15.00,
    pricePerChangingRoom: 15.00,
    pricePerKitchen: 10.00,
    largeMirrors: 20.00,
  },
  oneTimePricePerSqm: 3.75,
  minOneTime: 249.00,
  highTrafficFactor: 1.15,
  frequencyFactors: {
    "1xmonatlich": 1.30,
    "2xmonatlich": 1.15,
    "4xmonatlich": 1.00,
    "8xmonatlich": 0.95,
    "12xmonatlich": 0.95,
    "20xmonatlich": 0.95,
  },
};

export const STAIRCASE = {
  basePerEntrance: 49.00,
  addPerFloor: 18.00,
  additionalEntrancePct: 0.85,
  extras: {
    aufzug: 25.00,
    kellerflur: 20.00,
    hauseingangAussen: 15.00,
  },
  frequencyFactors: {
    einmalig: 2.60,
    "1xmonatlich": 1.45,
    "2xmonatlich": 1.15,
    "4xmonatlich": 1.00,
    "8xmonatlich": 0.95,
    "12xmonatlich": 0.95,
    "20xmonatlich": 0.95,
  },
};

export const WINDOWS = {
  standard: [
    { maxQty: 9, pricePerUnit: 15.00 },
    { maxQty: 19, pricePerUnit: 14.00 },
    { maxQty: Infinity, pricePerUnit: 13.00 },
  ],
  klein: 9.00,
  zweifluegelig: 24.00,
  bodentief: 24.00,
  dachfenster: 22.00,
  schwerErreichbarZuschlagPct: 0.50,
  standaloneMinPrice: 99.00,
  soilFactors: {
    leicht: 1.00,
    mittel: 1.20,
    stark: 1.50,
    sonder: null,
  },
};

export const SOIL_FACTORS = {
  normal: 1.00,
  deutlich: 1.20,
  stark: 1.40,
  extrem: null,
};

export const PAINTING = {
  // Kundenpreis pro m² Bodenfläche, ohne Netto-/Brutto-Auszeichnung im Rechner.
  wallsPricePerSqm: 20.00,
  ceilingPriceAddonPerSqm: 5.00,
  minPrice: 600.00,
  wallColorFactors: {
    hell: 1.00,
    gelbDunkel: 1.25,
    sehrDunkel: 1.35,
    sperrgrund: 1.45,
  },
  highCeilingFactor: 1.15,
  furnitureFactor: 1.10,
  smallRepairsFactor: 1.05,
};

export const LABELS = {
  serviceTypes: SERVICE_TYPES,
  customerTypes: {
    privat: "Privatkunde",
    unternehmen: "Unternehmen",
    hausverwaltung: "Hausverwaltung",
    praxis: "Praxis / Kanzlei",
  },
  objectTypes: {
    wohnung: "Wohnung",
    haus: "Haus",
    buero: "Büro",
    praxis: "Praxis",
    treppenhaus: "Treppenhaus",
    fitnessstudio: "Fitnessstudio",
    pilatesstudio: "Pilatesstudio",
    yogastudio: "Yogastudio",
    studio: "Allgemeines Studio",
    fenster: "Nur Fensterreinigung",
    sonstiges: "Sonstiges Objekt",
  },
  frequencies: {
    einmalig: "Einmalig",
    "1xmonatlich": "1 × im Monat",
    "2xmonatlich": "2 × im Monat",
    "4xmonatlich": "4 × im Monat",
    "8xmonatlich": "8 × im Monat",
    "12xmonatlich": "12 × im Monat",
    "20xmonatlich": "20 × im Monat",
    individuell: "Individueller Turnus",
  },
  soilLevels: {
    normal: "Normal",
    deutlich: "Deutlich verschmutzt",
    stark: "Stark verschmutzt",
    extrem: "Extrem verschmutzt / Besichtigung erforderlich",
  },
  windowSoilLevels: {
    leicht: "Leicht verschmutzt",
    mittel: "Mittel verschmutzt",
    stark: "Stark verschmutzt",
    sonder: "Sonderverschmutzung",
  },
  balconySizes: {
    klein: "Klein (bis 5 m²)",
    mittel: "Mittel (6–10 m²)",
    gross: "Groß (11–20 m²)",
    sehrGross: "Sehr groß (über 20 m²)",
  },
  balconySoilLevels: {
    leicht: "Leicht verschmutzt",
    mittel: "Mittel verschmutzt",
    stark: "Stark verschmutzt",
  },
  weeds: {
    kein: "Kein Unkraut",
    wenig: "Wenig Unkraut",
    viel: "Viel Unkraut",
  },
  housingCleaningTypes: {
    occupied: "Bewohnte Wohnung – Standardreinigung",
    end: "Endreinigung nach Auszug",
  },
  officeOneTimeTypes: {
    standard: "Einmalige Standardreinigung",
    grund: "Intensive Grundreinigung",
  },
  paintingScopes: {
    waende: "Nur Wände",
    waendeDecken: "Wände und Decken",
  },
  paintingColors: {
    hell: "Hell / Weiß / Pastell",
    gelbDunkel: "Kräftig gelb oder dunkel",
    sehrDunkel: "Sehr dunkel / starke Vergilbung",
    sperrgrund: "Nikotin, Ruß, Wasserflecken oder Sperrgrund nötig",
  },
  paintingConditions: {
    normal: "Normaler Zustand",
    klein: "Kleine Bohrlöcher oder leichte Risse",
    gross: "Größere Spachtelarbeiten / stark beschädigt",
    tapete: "Tapete entfernen",
    schimmel: "Schimmel oder Feuchtigkeitsschaden",
  },
};
